import {observable, action, runInAction} from 'mobx'
import rulesManagementAPI from '../apis/rulesManagementAPI'
import alertMessage from '../utils/alertMessage'
import moment from 'moment'
import {Base64} from 'js-base64'

export default class rulesManagementStore {
  constructor(rootStore) {
    this.rootStore = rootStore
  }

  @observable isFetching = false
  @observable typeList = []
  @observable tableList = []
  @observable triggerTypeList = []
  @observable operatorList = []
  @observable filedList = []
  @observable valueTypeList = []
  @observable joinList = []
  @observable tableData = []
  @observable ruleDetail = {}
  @observable SQLDetail = {}
  @observable ruleLogList = []
  @observable versionList = []
  @observable statusList = []

  @action
  async getDropdown(value) {
    this.isFetching = true
    try {
      const response = await rulesManagementAPI.getDropdown(value)
      runInAction(() => {
        this.isFetching = false
        switch (value) {
          case 'RuleTriggerTypeEnum':
            this.triggerTypeList = response.data.data
            break
          case 'RuleWhereOperatorEnum':
            this.operatorList = response.data.data
            break
          case 'RuleWhereTypeEnum':
            this.valueTypeList = response.data.data
            break
          case 'RuleWhereJoinEnum':
            this.joinList = response.data.data
            break
          case 'RuleTriggerStatusEnum':
            this.statusList = response.data.data
            break
          default:
            this.typeList = response.data.data
            break
        }
      })
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  @action
  async getTableNameLinkage() {
    this.isFetching = true
    try {
      const response = await rulesManagementAPI.getTableNameLinkage()
      runInAction(() => {
        this.isFetching = false
        this.tableList = response.data.data
      })
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  @action
  async getRuleData(params) {
    this.isFetching = true
    try {
      const response = await rulesManagementAPI.getRuleData(params)
      runInAction(() => {
        this.isFetching = false
        this.tableData = response.data.data?.records
      })
      return response
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  @action
  async submitRule(params, type, id = null) {
    this.isFetching = true
    try {
      const finalParams = this.submitFormat(params)
      if (type === 'edit') {
        finalParams.id = id
        finalParams.editRuleSetList = finalParams.addRuleSetList
        finalParams.editRuleWhereList = finalParams.addRuleWhereList
      }
      const response = type === 'add' ? await rulesManagementAPI.addRule(finalParams) : await rulesManagementAPI.editRule(finalParams)
      runInAction(() => {
        this.isFetching = false
      })
      return response
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  submitFormat(data) {
    data.triggerDate = data.triggerDateOrigin ? moment(data.triggerDateOrigin).format('YYYY-MM-DD HH:00') : null
    // data.triggerDate = data.triggerDate ? dateUtil.toString(data.triggerDate) : null
    data.addRuleSetList.forEach(item => {
      let lastIndex = item.field.value.lastIndexOf(item.field.label)
      if (lastIndex === -1) lastIndex = item.field.value.length
      item.fieldName = item.field.label
      item.fieldType = item.field.value.substring(0, lastIndex)
      item.fieldValue = item.field.value === 'date' ? moment(item.fieldValueOrigin).format('YYYY-MM-DD HH:ss:mm') : item.fieldValueOrigin
      // item.fieldValue = item.field.value === 'date' ? dateUtil.toString(item.fieldValue) : item.fieldValue
    })
    data.addRuleWhereList = []
    data.addRuleWhereOriginList.forEach(item => data.addRuleWhereList.push(item.parent))
    data.addRuleWhereList.forEach(item => {
      item.forEach(subItem => {
        let lastIndex = subItem.field.value.lastIndexOf(subItem.field.label)
        if (lastIndex === -1) lastIndex = subItem.field.value.length
        subItem.fieldName = subItem.field.label
        subItem.fieldType = subItem.field.value.substring(0, lastIndex)
        subItem.value = (subItem.fieldType === 'date' && subItem.valueType === 'Value' && subItem.valueOrigin) ? moment(subItem.valueOrigin).format('YYYY-MM-DD HH:ss:mm') : subItem.valueOrigin
        // subItem.value = (subItem.fieldType === 'date' && subItem.valueType === 'Value') ? dateUtil.toString(subItem.value) : subItem.value
      })
    })
    return data
  }

  @action
  async getRuleDetail(params) {
    this.isFetching = true
    try {
      const response = await rulesManagementAPI.getRuleDetail(params)
      runInAction(() => {
        this.isFetching = false
        const {data} = response.data
        this.ruleDetail = this.formatDate(data)
        this.onTableNameChange(this.ruleDetail.tableName)
      })
      return response
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  formatDate(data) {
    data.ruleSetList.forEach(item => {
      item.field = {'value': item.fieldType, 'label': item.fieldName}
      item.fieldValueOrigin = item.fieldType === 'date' ? moment(item.fieldValue, moment.ISO_8601) : item.fieldValue
    })

    data.addRuleWhereOriginList = []
    data.ruleWhereList.forEach(item => data.addRuleWhereOriginList.push({'parent': item}))
    data.addRuleWhereOriginList.forEach(item => {
      item.parent.forEach(subItem => {
        subItem.field = {'value': subItem.fieldType, 'label': subItem.fieldName}
        subItem.valueOrigin = (subItem.fieldType === 'date' && subItem.valueType === 'Value') ? moment(subItem.value, moment.ISO_8601) : subItem.value
      })
    })
    data.triggerDateOrigin = data.triggerDate ? moment(data.triggerDate, moment.ISO_8601) : null
    return data
  }

  @action
  async deleteRule(params) {
    this.isFetching = true
    try {
      await rulesManagementAPI.deleteRule(params)
      runInAction(() => {
        this.isFetching = false
      })
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  @action
  async submitSQL(params, type, id) {
    this.isFetching = true
    try {
      params.triggerDate = params.triggerDate ? moment(params.triggerDate).format('YYYY-MM-DD HH:00') : null
      params.sftpPath = params.sftpPath && Base64.encode(params.sftpPath)
      params.sqlScript = params.sqlScript && Base64.encode(params.sqlScript)
      params.id = type === 'edit' ? id : null
      const response = type === 'add' ? await rulesManagementAPI.addSQL(params) : await rulesManagementAPI.editSQL(params)
      runInAction(() => {
        this.isFetching = false
      })
      return response
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  @action
  async getSQLDetail(params) {
    this.isFetching = true
    try {
      const response = await rulesManagementAPI.getSQLDetail(params)
      runInAction(() => {
        this.isFetching = false
        const {data} = response.data

        data.triggerDate = data.triggerDate ? moment(data.triggerDate, moment.ISO_8601) : null
        this.SQLDetail = data
      })
      return response
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  @action
  async onActiveChange(params) {
    this.isFetching = true
    try {
      const response = await rulesManagementAPI.onActiveChange(params)
      runInAction(() => {
        this.isFetching = false
      })
      return response
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  @action
  async getRuleStatusLog(id) {
    this.isFetching = true
    try {
      const response = await rulesManagementAPI.getRuleStatusLog({id})
      runInAction(() => {
        this.isFetching = false
        this.ruleLogList = response.data.data
      })
      return response
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  @action
  onTableNameChange = value => {
    this.filedList = this.tableList.filter(item => item.tableName === value)[0]?.filedVoList
  }

  @action
  async getVersionList(id) {
    this.isFetching = true
    try {
      const response = await rulesManagementAPI.getVersionList({ruleId: id})
      runInAction(() => {
        this.isFetching = false
        this.versionList = response.data.data
      })
      return response
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  @action
  async onRecord(params) {
    this.isFetching = true
    try {
      const response = await rulesManagementAPI.onRecord(params)
      runInAction(() => {
        this.isFetching = false
        this.getVersionList(params.ruleId)
      })
      return response
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  @action
  async getVersionDetail(params) {
    this.isFetching = true
    try {
      const response = params.type === 'Rule' ? await rulesManagementAPI.getRuleVersionDetail(params) : await rulesManagementAPI.getSQLVersionDetail(params)
      runInAction(() => {
        this.isFetching = false
        const {data} = response.data

        if (params.type === 'Rule') {
          this.ruleDetail = this.formatDate(data)
          this.onTableNameChange(this.ruleDetail.tableName)
        } else {
          data.triggerDate = data.triggerDate ? moment(data.triggerDate, moment.ISO_8601) : null
          this.SQLDetail = data
        }
      })
      return response
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  @action
  async onRecover(params) {
    this.isFetching = true
    try {
      const response = await rulesManagementAPI.onRecover(params)
      runInAction(() => {
        this.isFetching = false
        this.getVersionList(params.ruleId)
      })
      return response
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  @action
  async importRulesPre(params, uuid) {
    this.isFetching = true
    try {
      const finalParams = this.submitFormat(params)
      finalParams.uuid = uuid
      const response = await rulesManagementAPI.importRulesPre(finalParams)
      runInAction(() => {
        this.isFetching = false
      })
      return response
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }
}
